import React, { useState } from 'react';
import { Container, Navbar, Nav, Row, Col, Card, Button} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import ServicesSection from './ServicesSection';
import ImageCarousel from "./ImageCarousel";
import InteractiveImageGrid from './InteractiveImageGrid';
import Footer from './Footer';
import './App.css';

function App() {

  return (
    <>
      {/* Navbar */}
      <Navbar className="custom-navbar" expand="lg" fixed="top">
  <Container>
    <Navbar.Brand href="#home"><img src={require('./navbar.jpg') } className="navpic"/></Navbar.Brand>
    <Navbar.Toggle aria-controls="basic-navbar-nav" />
    <Navbar.Collapse id="basic-navbar-nav">
      <Nav className="ml-auto d-flex align-items-center">   
        <Nav.Link href="#about">แนะนำแพทย์</Nav.Link>
        <Nav.Link href="#testimonials">บริการของเรา</Nav.Link>
        <Nav.Link href="#contact">การตรวจโดยผู้เชี่ยวชาญเพื่อหาสาเหตุของโรคหัวใจ</Nav.Link>
        <Nav.Link href="#footer">ติดต่อคุณหมอ</Nav.Link>
      </Nav>
    </Navbar.Collapse>
  </Container>
</Navbar>


      {/*Content Section */}
<section id="home" >
  <section id="hero">
  <Container>
    <Row className="align-items-center">
      {/* คอลัมน์สำหรับรูปภาพ */}
      <Col xs={12} md={6} className="mb-4">
      <img
        src={require('./doctor_portrait.png')}
        alt="คลินิกหัวใจหมอธนพฤธ"
        className="rounded portrait-img"
      />
    </Col>

      {/* คอลัมน์สำหรับข้อความ */}
      <Col xs={12} md={6} className="text-center">
      <img
        src={require('./Heart_Clinic_Logo.png')}
        alt="คลินิกหัวใจหมอธนพฤธ"
        className="rounded logo-img mb-4"
      />
      <h1>คลินิกหัวใจหมอธนพฤธ นครศรีธรรมราช</h1>
      <h3>Heart Clinic Nakhonsithammarat</h3>
      <h3>มีปัญหาหัวใจ ไว้ใจเรา</h3>
      <Button variant="primary" href="http://m.me/Thanaphruetclinic/" className="mt-3">
        นัดพบคุณหมอ
      </Button>
      <br />
    </Col>
  </Row>
  </Container>
    </section>
   <Container>
      <div className="content-box"> 
    <ImageCarousel />
      </div> 
    </Container>
      {/* About Section */}
      <section id="about" className="about-section">
      <br />
        <Container>
        <div className="content-box">
          <h2 className="text-center">แนะนำแพทย์</h2>
          <h3>นายแพทย์ธนพฤธ  อิสระวัฒนา</h3>
          <h4>ผู้เชี่ยวชาญด้านอายุรแพทย์โรคหัวใจ หัตถการรักษาหลอดเลือดหัวใจ</h4>
          <h4>Interventional cardiology</h4>
          <Row>
            <Col md={6}>
              <Card className="styled-card">
                <Card.Body>
                  <Card.Title>ความเชี่ยวชาญ</Card.Title>
                  <Card.Text>- ดูแลผู้ป่วยโรคทางอายุรกรรมและโรคหัวใจและหลอดเลือดหัวใจอย่างทันสมัย</Card.Text>
                  <Card.Text>- ให้คำแนะนำแนวทางการตรวจเพิ่มเติม และการรักษาตามมาตรฐาน</Card.Text>
                  <Card.Text>- ตรวจและแปลผลคลื่นไฟฟ้าหัวใจ(ECG) วิ่งสายพาน(EST) และอัลตร้าซาวด์หัวใจ(ECHO) อย่างถูกต้องแม่นยำ</Card.Text>
                  <Card.Text>- หัตถการสวนหัวใจ ฉีดสี ทำบอลลูนขยายหลอดเลือดและใส่ขดลวดหลอดเลือดหัวใจ</Card.Text>
                  <Card.Text>- ประสบการณ์ดูแลผู้ป่วย และทำหัตถการปฏิบัติการหลอดเลือดหัวใจมามากกว่า 1000 ราย</Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6}>
              <Card className="styled-card">
                <Card.Body>
                  <Card.Title>ประวัติการศึกษา</Card.Title>
                  <Card.Text>- แพทยศาสตร์บัณฑิต <br /> คณะแพทยศาสตร์ <br /> โรงพยาบาลสงขลานครินทร์ (เกียรตินิยมอันดับ1)</Card.Text>
                  <Card.Text>- วุฒิบัตรเป็นผู้มีความรู้ความชำนาญในการประกอบวิชาชีพเวชกรรม <br />สาขาอายุรศาสตร์ (Internal medicine)<br /> คณะแพทยศาสตร์ โรงพยาบาลสงขลานครินทร์ </Card.Text>
                  <Card.Text>- วุฒิบัตรเป็นผู้มีความรู้ความชำนาญในการประกอบวิชาชีพเวชกรรม <br />อนุสาขาอายุรศาสตร์โรคหัวใจ (Cardiology) <br />โรงพยาบาลรามาธิบดี </Card.Text>
                  <Card.Text>- วุฒิบัตรเป็นผู้มีความรู้ความชำนาญในการประกอบวิชาชีพเวชกรรม<br />อนุสาขาอายุรศาสตร์หัตถการปฏิบัติรักษาโรคหัวใจและหลอดเลือด (Interventional cardiology)<br />โรงพยาบาลรามาธิบดี </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          </div>
        </Container>
      </section>

      {/* Testimonials Section */}
      <section id="testimonials" className="about-section">
      <br />
      <ServicesSection />
      </section>

      {/* Services Section  */}
      <section id="contact" >
      <br />>
        <Container>
        <div>
        <InteractiveImageGrid />
        </div>
        </Container>
      </section>

</section >
<section id="footer">
      {/* Footer */}
      <Footer />
</section>
    </> 
  );
}

export default App;